import { Address } from './contact';
import { InvoiceDelivery, InvoicingType, InvoicePeriod } from './invoice';

export type ContactInformation = {
    name: string;
    email: string;
    phone: string;
};

export type InvoiceSettings = {
    emailSettings: EmailSettings;
    type?: InvoicingType;
    paymentTerms?: number;
    invoiceFee?: Monetary;
    deliveryFee?: Monetary;
    invoiceDelivery?: InvoiceDelivery;
    invoicePeriod?: InvoicePeriod;
    invoiceText?: string;
    fortnoxCustomerNo?: string;
    vismaCustomerId?: string;
    contactInformation?: ContactInformation;
    showPatientPIN?: boolean;
    isDeliveryNoteAttached?: boolean;
    isDeliveryNotesMergedWithInvoice?: boolean;
    invoiceAddress: Address;
    supplierReference?: string;
    isOverwritten?: boolean;
};

export type EmailSettings = {
    replyAddress?: string;
    to?: string[];
    cc?: string[];
    bcc?: string[];
    subject?: string;
    body?: string;
    creditSubject?: string;
    creditBody?: string;
};

export type Monetary = {
    price?: number;
    currency?: string;
};

export enum CustomerType {
    ALL = 'ALL',
    DENTHUB_CONNECTED = 'DENTHUB_CONNECTED',
    MY_CLIENT = 'MY_CLIENT',
    WHITE_LABEL = 'WHITE_LABEL',
    SUPPLIER = 'SUPPLIER',
}

export enum ClientStatus {
    SHOW_ACTIVE = 'SHOW_ACTIVE',
    SHOW_INACTIVE = 'SHOW_INACTIVE',
    SHOW_ALL = 'SHOW_ALL',
}
